import Module, { registerModuleClass } from '@sparta.global.utilities/sparta-module-utility/dist/es6.js';
import spartaMediaQueryUtility from '@sparta.global.utilities/sparta-mediaquery-utility/dist/es6.js';
import spartaEventsUtility from '@sparta.global.utilities/sparta-events-utility/dist/es6.js';
import Siema from '@sparta.global.vendors/siema';
import _ from '@sparta.global.vendors/lodash';
import Handlebars from '@sparta.global.vendors/handlebars';
import { button } from '@sparta.global.helpers/button-helper/dist/es6.js';
import { nTimes } from '@sparta.merrill-homepage.helpers/merrill-homepage/dist/es6.js';
import { link } from '@sparta.global.helpers/sparta-helper/dist/es6.js';

const Template = Handlebars.template({"1":function(container,depth0,helpers,partials,data) {
    var stack1, lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return "<div class=\"row header-row\">\r\n  <h3 class=\"carousel-header column small-12\">\r\n    "
    + ((stack1 = container.lambda(((stack1 = (depth0 != null ? lookupProperty(depth0,"data") : depth0)) != null ? lookupProperty(stack1,"header") : stack1), depth0)) != null ? stack1 : "")
    + "\r\n  </h3>\r\n</div>\r\n";
},"3":function(container,depth0,helpers,partials,data) {
    var stack1, lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return "<div class=\"row header-row\">\r\n  <p class=\"carousel-subheader column small-11\">\r\n    "
    + ((stack1 = container.lambda(((stack1 = (depth0 != null ? lookupProperty(depth0,"data") : depth0)) != null ? lookupProperty(stack1,"subheader") : stack1), depth0)) != null ? stack1 : "")
    + "\r\n  </p>\r\n</div>\r\n";
},"5":function(container,depth0,helpers,partials,data) {
    var stack1, helper, lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return "        <div class=\"tile\">\r\n          <div class=\"tile-image-container\">\r\n            <img class=\"tile-image\" src=\""
    + container.escapeExpression(((helper = (helper = lookupProperty(helpers,"image") || (depth0 != null ? lookupProperty(depth0,"image") : depth0)) != null ? helper : container.hooks.helperMissing),(typeof helper === "function" ? helper.call(depth0 != null ? depth0 : (container.nullContext || {}),{"name":"image","hash":{},"data":data,"loc":{"start":{"line":22,"column":41},"end":{"line":22,"column":50}}}) : helper)))
    + "\" loading=\"lazy\" alt=\"\" />\r\n          </div>\r\n          <div class=\"tile-link-text\">\r\n            <p class=\"tile-link-content\">"
    + ((stack1 = ((helper = (helper = lookupProperty(helpers,"content") || (depth0 != null ? lookupProperty(depth0,"content") : depth0)) != null ? helper : container.hooks.helperMissing),(typeof helper === "function" ? helper.call(depth0 != null ? depth0 : (container.nullContext || {}),{"name":"content","hash":{},"data":data,"loc":{"start":{"line":25,"column":41},"end":{"line":25,"column":54}}}) : helper))) != null ? stack1 : "")
    + "</p>\r\n            <p class=\"tile-link-description\">"
    + ((stack1 = ((helper = (helper = lookupProperty(helpers,"description") || (depth0 != null ? lookupProperty(depth0,"description") : depth0)) != null ? helper : container.hooks.helperMissing),(typeof helper === "function" ? helper.call(depth0 != null ? depth0 : (container.nullContext || {}),{"name":"description","hash":{},"data":data,"loc":{"start":{"line":26,"column":45},"end":{"line":26,"column":62}}}) : helper))) != null ? stack1 : "")
    + "</p>\r\n            "
    + container.escapeExpression((lookupProperty(helpers,"button")||(depth0 && lookupProperty(depth0,"button"))||container.hooks.helperMissing).call(depth0 != null ? depth0 : (container.nullContext || {}),(depth0 != null ? lookupProperty(depth0,"learnMore") : depth0),{"name":"button","hash":{},"data":data,"loc":{"start":{"line":27,"column":12},"end":{"line":27,"column":32}}}))
    + "\r\n          </div>\r\n        </div>\r\n";
},"7":function(container,depth0,helpers,partials,data) {
    var stack1, lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return "  <div class=\"row\">\r\n    <div class=\"link-container\">\r\n      <span>"
    + container.escapeExpression((lookupProperty(helpers,"link")||(depth0 && lookupProperty(depth0,"link"))||container.hooks.helperMissing).call(depth0 != null ? depth0 : (container.nullContext || {}),((stack1 = ((stack1 = (depth0 != null ? lookupProperty(depth0,"data") : depth0)) != null ? lookupProperty(stack1,"LINKS") : stack1)) != null ? lookupProperty(stack1,"compareLink") : stack1),{"name":"link","hash":{},"data":data,"loc":{"start":{"line":37,"column":12},"end":{"line":37,"column":43}}}))
    + "</span>\r\n      <div class=\"spa-icon arrow-forward\"></div>\r\n    </div>\r\n  </div>\r\n";
},"9":function(container,depth0,helpers,partials,data) {
    return "					<span class=\"nav-item\" data-nav-dot=\""
    + container.escapeExpression(container.lambda(depth0, depth0))
    + "\"></span>\r\n";
},"11":function(container,depth0,helpers,partials,data) {
    var stack1, lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return "  <div class=\"row\">\r\n    <div class=\"link-container\">\r\n      <span>"
    + container.escapeExpression((lookupProperty(helpers,"link")||(depth0 && lookupProperty(depth0,"link"))||container.hooks.helperMissing).call(depth0 != null ? depth0 : (container.nullContext || {}),((stack1 = ((stack1 = (depth0 != null ? lookupProperty(depth0,"data") : depth0)) != null ? lookupProperty(stack1,"LINKS") : stack1)) != null ? lookupProperty(stack1,"compareLink") : stack1),{"name":"link","hash":{},"data":data,"loc":{"start":{"line":78,"column":12},"end":{"line":78,"column":43}}}))
    + "</span>\r\n    </div>\r\n  </div>\r\n";
},"compiler":[8,">= 4.3.0"],"main":function(container,depth0,helpers,partials,data) {
    var stack1, lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return ((stack1 = lookupProperty(helpers,"if").call(depth0 != null ? depth0 : (container.nullContext || {}),((stack1 = (depth0 != null ? lookupProperty(depth0,"data") : depth0)) != null ? lookupProperty(stack1,"header") : stack1),{"name":"if","hash":{},"fn":container.program(1, data, 0),"inverse":container.noop,"data":data,"loc":{"start":{"line":1,"column":0},"end":{"line":7,"column":7}}})) != null ? stack1 : "")
    + ((stack1 = lookupProperty(helpers,"if").call(depth0 != null ? depth0 : (container.nullContext || {}),((stack1 = (depth0 != null ? lookupProperty(depth0,"data") : depth0)) != null ? lookupProperty(stack1,"subheader") : stack1),{"name":"if","hash":{},"fn":container.program(3, data, 0),"inverse":container.noop,"data":data,"loc":{"start":{"line":8,"column":0},"end":{"line":14,"column":7}}})) != null ? stack1 : "")
    + "<div class=\"row large-carousel\">\r\n  <div class=\"small-12 column\">\r\n    <div id=\"carousel-container\">\r\n      <div id=\"largeSiemaCarousel\" class=\"carousel\">\r\n"
    + ((stack1 = lookupProperty(helpers,"each").call(depth0 != null ? depth0 : (container.nullContext || {}),((stack1 = (depth0 != null ? lookupProperty(depth0,"data") : depth0)) != null ? lookupProperty(stack1,"tiles") : stack1),{"name":"each","hash":{},"fn":container.program(5, data, 0),"inverse":container.noop,"data":data,"loc":{"start":{"line":19,"column":8},"end":{"line":30,"column":17}}})) != null ? stack1 : "")
    + "      </div>\r\n    </div>\r\n  </div>\r\n"
    + ((stack1 = lookupProperty(helpers,"if").call(depth0 != null ? depth0 : (container.nullContext || {}),((stack1 = (depth0 != null ? lookupProperty(depth0,"data") : depth0)) != null ? lookupProperty(stack1,"compareLink") : stack1),{"name":"if","hash":{},"fn":container.program(7, data, 0),"inverse":container.noop,"data":data,"loc":{"start":{"line":34,"column":2},"end":{"line":41,"column":9}}})) != null ? stack1 : "")
    + "</div>\r\n<div class=\"row mobile-carousel\">\r\n  <div class=\"small-12 column\">\r\n    <div id=\"carousel-container\">\r\n      <div id=\"mobileSiemaCarousel\" class=\"carousel\">\r\n"
    + ((stack1 = lookupProperty(helpers,"each").call(depth0 != null ? depth0 : (container.nullContext || {}),((stack1 = (depth0 != null ? lookupProperty(depth0,"data") : depth0)) != null ? lookupProperty(stack1,"tiles") : stack1),{"name":"each","hash":{},"fn":container.program(5, data, 0),"inverse":container.noop,"data":data,"loc":{"start":{"line":47,"column":8},"end":{"line":58,"column":17}}})) != null ? stack1 : "")
    + "      </div>\r\n			<div class=\"carousel-action-btns\">\r\n				<div class=\"chevron-container chevron-container-left\">\r\n					"
    + container.escapeExpression((lookupProperty(helpers,"button")||(depth0 && lookupProperty(depth0,"button"))||container.hooks.helperMissing).call(depth0 != null ? depth0 : (container.nullContext || {}),((stack1 = (depth0 != null ? lookupProperty(depth0,"data") : depth0)) != null ? lookupProperty(stack1,"siemaPrev") : stack1),{"name":"button","hash":{},"data":data,"loc":{"start":{"line":62,"column":5},"end":{"line":62,"column":30}}}))
    + "\r\n				</div>\r\n				<div class=\"small-carousel-dot-nav\">\r\n"
    + ((stack1 = (lookupProperty(helpers,"nTimes")||(depth0 && lookupProperty(depth0,"nTimes"))||container.hooks.helperMissing).call(depth0 != null ? depth0 : (container.nullContext || {}),3,{"name":"nTimes","hash":{},"fn":container.program(9, data, 0),"inverse":container.noop,"data":data,"loc":{"start":{"line":65,"column":5},"end":{"line":67,"column":16}}})) != null ? stack1 : "")
    + "				</div>\r\n				<div class=\"chevron-container chevron-container-right\">\r\n					"
    + container.escapeExpression((lookupProperty(helpers,"button")||(depth0 && lookupProperty(depth0,"button"))||container.hooks.helperMissing).call(depth0 != null ? depth0 : (container.nullContext || {}),((stack1 = (depth0 != null ? lookupProperty(depth0,"data") : depth0)) != null ? lookupProperty(stack1,"siemaNext") : stack1),{"name":"button","hash":{},"data":data,"loc":{"start":{"line":70,"column":5},"end":{"line":70,"column":30}}}))
    + "\r\n				</div>\r\n			</div>\r\n    </div>\r\n  </div>\r\n"
    + ((stack1 = lookupProperty(helpers,"if").call(depth0 != null ? depth0 : (container.nullContext || {}),((stack1 = (depth0 != null ? lookupProperty(depth0,"data") : depth0)) != null ? lookupProperty(stack1,"compareLink") : stack1),{"name":"if","hash":{},"fn":container.program(11, data, 0),"inverse":container.noop,"data":data,"loc":{"start":{"line":75,"column":2},"end":{"line":81,"column":9}}})) != null ? stack1 : "")
    + "</div>";
},"useData":true});
const renderTemplate = function (data, options) {
  return Template(data, options);
};

// Import templates & helpers
var _moduleConfig = {
  "name": "@sparta.merrill-homepage.modules/carousel-module",
  "version": "1.1.1",
  "id": "CarouselModule",
  "containerID": "merrillHomepageCarouselModule",
  "moduleName": "merrill-homepage-carousel-module",
  "semantic": true,
  "superModule": false,
  "viewPort": ["small", "medium", "large"],
  "tag": "div",
  "nameSpace": "carousel-module",
  "data": {
    "init": "CarouselModule",
    "options": {}
  },
  "moduleParams": [],
  "layout": "layout",
  "render": function (context) {
    return renderTemplate(context, {
      "helpers": {
        button,
        nTimes,
        link
      },
      "partials": {}
    });
  },
  "template": renderTemplate,
  "partials": {},
  "helpers": {
    button,
    nTimes,
    link
  },
  "dependencies": {
    "@sparta.global.helpers/button-helper": "^1.0.0",
    "@sparta.global.helpers/sparta-helper": "^1.0.0",
    "@sparta.global.utilities/sparta-events-utility": "^1.0.0",
    "@sparta.global.utilities/sparta-mediaquery-utility": "^1.0.0",
    "@sparta.global.utilities/sparta-module-utility": "^1.0.5",
    "@sparta.global.utilities/sparta-style-token-utility": "^1.1.9",
    "@sparta.global.vendors/handlebars": "^4.7.7",
    "@sparta.global.vendors/lodash": "^4.0.0",
    "@sparta.global.vendors/siema": "^1.0.0",
    "@sparta.merrill-homepage.helpers/merrill-homepage": "^1.0.0"
  },
  "stores": []
};

/**
 * The CarouselModule Sparta Module.
 * carousel using siema carousel
 * @export
 * @class carouselModule
 * @extends Module
 */
class CarouselModule extends Module {
  /**
   * Creates an instance of CarouselModule.
   * @memberof CarouselModule
   * @param {Object} options Module options
   * @param {Object} context Module context
   */
  constructor(options, context) {
    super({
      ...options,
      context,
      config: _moduleConfig
    });
    this.currentSlideIndex = 0;
    this.largeSiema = {
      selector: '#largeSiemaCarousel',
      perPage: 3,
      startIndex: 0,
      draggable: true,
      threshold: 50,
      loop: false,
      duration: 200,
      easing: 'ease-in-out',
      onInit: () => this.onInitCallback(),
      onChange: () => this.onChangeCallback()
    };
    this.mobileSiema = {
      selector: '#mobileSiemaCarousel',
      perPage: {
        767: 1,
        768: 3
      },
      startIndex: 0,
      draggable: true,
      threshold: 50,
      loop: true,
      duration: 200,
      easing: 'ease-in-out',
      onInit: () => this.onInitCallback(),
      onChange: () => this.onChangeCallback()
    };
  }

  /**
   * Called when this module is bootstrapped by the client.
   * @param {object} options The options this module was initialized with.
   * @returns {void}
   */
  init() {
    this.initSliders();
    this.bindListeners();
  }

  /**
   * @returns {boolean} boolean
   */
  isSmallView() {
    return spartaMediaQueryUtility.getCurrentViewport().currentViewport.indexOf('small') > -1;
  }

  /**
   * Initialize the sliders for large and small viewports only once
   * @returns {void}
   */
  initSliders() {
    this.initCarousel();
    this.setBackgroundImages();

    // refresh on resize to prevent bugs in carousel
    this.Events.sub(spartaMediaQueryUtility.EVENTS.BREAKPOINT_CHANGE, () => {
      this.initCarousel();
    });
  }

  /**
   * Sets the background images (CSP-compliant)
   * @returns {void}
   */
  setBackgroundImages() {
    const targetElements = document.querySelectorAll('[loading]');
    [...targetElements].forEach(el => {
      // Positioning MGI-Homepage-tile background to fit the tile-container
      if (el.style.background.includes('MGI-Homepage-tile')) {
        el.classList.add('mgi-tile-bg-position');
      }
    });
  }

  /**
   * Initialize the carousel based on page size
   * @returns {void}
   */
  initCarousel() {
    if (this.carousel) {
      this.carousel.destroy(true);
    }
    const {
      mediaQueryInfo
    } = spartaMediaQueryUtility.getCurrentViewport();

    // if large-up, create large carousel with no looping
    if (mediaQueryInfo.large) {
      this.carousel = new Siema(this.largeSiema);
      this.setMaxHeight();
      // if small or medium, create looping carousel with arrows to move through tiles
    } else {
      this.carousel = new Siema(this.mobileSiema);
      this.setMaxHeight();
      const prev = document.getElementById('siemaCarouselPrev').parentElement;
      const next = document.getElementById('siemaCarouselNext').parentElement;
      prev.addEventListener('click', () => this.prevHandler(this.carousel));
      next.addEventListener('click', () => this.nextHandler(this.carousel));
    }
  }

  /**
   * Bind handlers to respective elements
   * Listen for window breakpoint change to select slider to show
   * @returns {void}
   */
  bindListeners() {
    spartaEventsUtility.sub(spartaMediaQueryUtility.EVENTS.BREAKPOINT_CHANGE, _.debounce(this.initSliders.bind(this), 250));
    this.navDots = Array.from(this.settings.target.querySelectorAll('.nav-item'));
    if (this.navDots) {
      this.navDots.forEach(dot => {
        dot.addEventListener('click', this.handleNavClick.bind(this));
      });
    }
    // Siema has a resize event listener that is wiping out the aria attributes.
    window.addEventListener('resize', _.debounce(this.applyAda.bind(this), 250));
  }

  /**
   * Handle navigation click
   * @param {Event} e event
   * @returns {void}
   */
  handleNavClick(e) {
    if (this.carousel) {
      this.carousel.goTo(e.target.dataset.navDot);
    }
  }

  /**
   * Callback to show the carousel once it has initialized
   * @returns {void}
   */
  onInitCallback() {
    if (this.isSmallView()) {
      this.settings.target.querySelector('[data-nav-dot="0"]').classList.add('active');
      this.applyAda();
    }
  }

  /**
   * Apply ada fixes due to cloning of elements
   * @returns {void}
   */
  applyAda() {
    const {
      selector,
      perPage,
      loop
    } = this.mobileSiema;
    if (loop) {
      const carousel = document.querySelector(selector);
      const tiles = Array.from(carousel.querySelectorAll('.tile'));
      const clonesPrepend = tiles.slice(0, perPage);
      const clonesAppend = tiles.slice(-perPage);
      const clones = clonesPrepend.concat(clonesAppend);

      // Get rid of the tile link id duplicates
      clones.forEach(tile => {
        tile.parentNode.setAttribute('aria-hidden', 'true');
        const tileLink = tile.querySelector('.tile-link');
        if (tileLink && !tileLink.getAttribute('aria-hidden')) {
          tileLink.id = `${tileLink.id}Cloned`;
          tileLink.tabIndex = -1;
          tileLink.setAttribute('aria-hidden', 'true');
        }
      });
    }
  }

  /**
   * Callback for handling change in small Carousel
   * Used for updating the dot navigation elements
   * @returns {void}
   */
  onChangeCallback() {
    // Siema only updates the current slide AFTER it changes
    const newSlideIndex = this.carousel.currentSlide;
    if (newSlideIndex !== undefined) {
      const curActive = this.settings.target.querySelector('.active');
      if (curActive) {
        curActive.classList.remove('active');
      }
      const curSlide = this.settings.target.querySelector(`[data-nav-dot="${newSlideIndex}"]`);
      if (curSlide) {
        curSlide.classList.add('active');
      }
      this.currentSlideIndex = newSlideIndex;
    }
  }

  /**
   * Handler for clicking the next arrow
   * @param {Siema} siema - Instance of siema slider
   * @returns {void}
   */
  nextHandler(siema) {
    siema.next();
  }

  /**
   * Handler for clicking the prev arrow
   * @param {Siema} siema - Instance of siema slider
   * @returns {void}
   */
  prevHandler(siema) {
    siema.prev();
  }

  /**
   * @method setMaxHeight
   * @description set all tile heights to max tile height
   * @returns {void}
   */
  setMaxHeight() {
    const tiles = [...document.querySelectorAll('.tile')];
    const tileHeights = tiles.map(el => el.offsetHeight);
    const maxTileHeight = Math.max(...tileHeights);
    tiles.forEach(el => {
      // eslint-disable-next-line no-param-reassign
      el.style.height = `${maxTileHeight}px`;
    });
  }
}
registerModuleClass({
  moduleClass: CarouselModule,
  moduleConfig: _moduleConfig
});
const moduleConfig = _moduleConfig;

export { CarouselModule as default, moduleConfig };
